module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0060.jpg?v=898c3d0f";